import React, { useState } from 'react';
import { Kicker, CharReveal } from './ui';
function CopyChip({
  label,
  value
}: {
  label: string;
  value: string;
}) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      const ta = document.createElement('textarea');
      ta.value = value;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };
  return <button onClick={copy} className="font-monoui rounded-full border px-6 md:px-8 py-4 text-xs md:text-sm tracking-[0.12em] transition-colors hover:border-[var(--danfo)]" style={{
    borderColor: copied ? 'var(--danfo)' : 'var(--line)',
    color: copied ? 'var(--danfo)' : 'inherit'
  }} data-id="element-23">
      {copied ? 'Copied ✦' : label}
    </button>;
}
const SOCIALS = ['Instagram', 'X / Twitter', 'LinkedIn', 'Behance'];
const FOUNDER_IMG = 'https://images.unsplash.com/photo-1531384441138-2736e62e0919?auto=format&fit=crop&w=300&q=80';
export function Footer() {
  return <footer id="contact" className="pt-24 md:pt-32 border-t" style={{
    borderColor: 'var(--line)'
  }} data-id="element-24">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10" data-id="element-25">
        <Kicker ig="Ka Anyị Kwuo Okwu" en="Let's talk" data-id="element-26" />

        <h2 className="font-display uppercase tracking-tight leading-[0.9] mt-8 text-[19vw] md:text-[13vw]" data-id="element-27">
          <CharReveal text="Let's" step={44} data-id="element-28" />
          <span className="inline-block" style={{
          width: '0.22em'
        }} aria-hidden="true" data-id="element-29" />
          <CharReveal text="Talk" className="text-outline" baseDelay={260} step={48} data-id="element-30" />
          <span style={{
          color: 'var(--danfo)'
        }} data-id="element-31">
            <CharReveal text="." baseDelay={480} data-id="element-32" />
          </span>
        </h2>

        <div className="mt-10 md:mt-14 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-10" data-id="element-33">
          <div className="flex flex-wrap items-center gap-4" data-id="element-34">
            <CopyChip label="hello@nkali.studio" value="hello@nkali.studio" data-id="element-35" />
            <CopyChip label="+234 800 NKALI 00" value="+2348006525400" data-id="element-36" />
            <span className="font-monoui text-[11px] uppercase tracking-[0.16em] opacity-40" data-id="element-37">Click to copy</span>
          </div>

          <a href="#top" className="group flex items-center gap-5 rounded-2xl border p-5 md:p-6 transition-colors hover:border-[var(--danfo)] max-w-md" style={{
          background: 'var(--ink-2)',
          borderColor: 'var(--line)'
        }} data-id="element-38">
            <img src={FOUNDER_IMG} alt="Chidi Okafor, Creative Director at Nkali" loading="lazy" className="h-16 w-16 md:h-20 md:w-20 rounded-full object-cover border" style={{
            borderColor: 'var(--line)'
          }} data-id="element-39" />
            <span data-id="element-40">
              <span className="block font-display uppercase text-base md:text-lg tracking-tight" data-id="element-41">
                Book a 30 minute intro call
              </span>
              <span className="font-monoui block text-[11px] uppercase tracking-[0.16em] opacity-50 mt-1.5" data-id="element-42">
                Chidi Okafor · Creative Director
              </span>
            </span>
            <span className="ml-auto flex h-11 w-11 shrink-0 items-center justify-center rounded-full transition-transform group-hover:rotate-45" style={{
            background: 'var(--danfo)',
            color: 'var(--ink)'
          }} aria-hidden="true" data-id="element-43">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" data-id="element-44">
                <path d="M7 17L17 7M17 7H8M17 7V16" stroke="currentColor" strokeWidth="2.4" strokeLinecap="square" data-id="element-45" />
              </svg>
            </span>
          </a>
        </div>

        <div className="mt-14 md:mt-20 flex flex-wrap gap-x-10 gap-y-4" data-id="element-46">
          {SOCIALS.map(s => <a key={s} href="#top" className="font-monoui text-xs md:text-sm uppercase tracking-[0.18em] opacity-60 transition-opacity hover:opacity-100" data-id="element-47">
              {s} <span style={{
            color: 'var(--danfo)'
          }} data-id="element-48">↗</span>
            </a>)}
        </div>

        <div className="mt-14 md:mt-20 flex flex-col md:flex-row md:items-center justify-between gap-3 border-t py-6 md:py-8" style={{
        borderColor: 'var(--line)'
      }} data-id="element-49">
          <p className="font-monoui text-[10px] md:text-[11px] uppercase tracking-[0.16em] opacity-45" data-id="element-50">
            © 2026 Nkali Studio
          </p>
          <p className="font-monoui text-[10px] md:text-[11px] uppercase tracking-[0.16em] opacity-45" data-id="element-51">
            Nkali (Igbo): to be greater than
          </p>
          <p className="font-monoui text-[10px] md:text-[11px] uppercase tracking-[0.16em] opacity-45" data-id="element-52">
            Lagos / Worldwide
          </p>
        </div>
      </div>
    </footer>;
}